'use strict';

class PkLoader {
    /*@ngInject*/
    constructor($scope, $timeout, orderStore, $state, utils, $mdDialog) {
        "ngInject";
        _.extend(this, {
            $scope: $scope,
            $timeout: $timeout,
            orderStore: orderStore,
            $state: $state,
            utils: utils,
            $mdDialog: $mdDialog
        });

        $scope.$watch(
            () => this.load,
            (loader) => {
                if (this.done) {
                    this.done = false;
                }

                if (loader && _.isFunction(loader)) {
                    // Check if loader previously failed
                    // If so, re try up to a maximum of 3 times
                    const loadSuccess = loader.success,
                        hasFailed = loadSuccess === false;

                    const retries = loader.attempts || 0,
                        maxRetries = 3;

                    if (retries === maxRetries && hasFailed) {
                        loader.failed = true;
                        return false;
                    }

                    if (retries < maxRetries && hasFailed) {
                        loader.attempts += 1;
                        this.$timeout(() => {
                            this._loader = loader();
                            this._loader
                                .then(
                                    () => this.done = true,
                                    (error) => this.load.lastFailure = new Date().getTime()
                                );
                        }, Math.exp(loader.attempts) * 1000);
                        return false;
                    }

                    this._loader = loader();
                    this._loader
                        .then(
                            () => this.done = true,
                            (error) => this.handleKnownErrors(error)
                        );
                }

                // If we were passed a deferred, just track it
                if (loader && loader.then && _.isUndefined(loader.lastFailure)) {
                    this._loader = loader
                        .then(
                            () => {
                                this.done = true;
                            },
                            (response) => {
                                return this.handleKnownErrors(response);
                            }
                        );
                }

                if (!loader || _.isEmpty(loader)) {
                    this.done = true;
                }
            }
        )
    }

    handleKnownErrors(response) {
        this.load.lastFailure = new Date().getTime();

        const error = response.error,
            entityId = error && error.entityId,
            maxRetries = 3;

        let loader = this.load;
        /**
         * If the error object has an entity type,
         *  handle possible states right here and forgo retries.
         * If not, pass the error through
         */
        if (error && error.entityType) {
            const entityType = error.entityType,
                errorCode = error.code;

            // Do not allow any more retries
            loader.attempts = maxRetries;

            if (entityType === 'order') {
                // Add more error codes as we support them
                if (errorCode === this.orderStore.constants.UNSUPPORTED_ORDER_VERSION) {
                    this.UNSUPPORTED_ORDER_VERSION = true;
                    this.knownError = true;
                    this.entityId = error.entityId;
                    return false;
                }
                if(errorCode === this.orderStore.constants.FINALIZED_ORDER_EDIT) {
                    this.FINALIZED_ORDER_EDIT = true;
                    this.knownError = true;
                    this.entityId = error.entityId;
                    return false;
                }
                if(errorCode === this.orderStore.constants.EXPIRED_ORDER) {
                    this.EXPIRED_ORDER = true;
                    this.knownError = true;
                    this.entityId = error.entityId;
                    return false;
                }
            }

            if (entityType === 'quote') {
                // If no quotes for this order,
                //  redirect to acknowledgement page.
                if (errorCode === this.orderStore.constants.NO_QUOTES_FOR_ORDER) {
                    let nextState = this.utils.getAdminStateIfApplicable('base.acknowledge');
                    this.$state.go(nextState, {orderId: entityId});
                    return false;
                }
                if (errorCode === this.orderStore.constants.ORDER_NOT_QUOTED) {
                    this.ORDER_NOT_QUOTED = true;
                    this.knownError = true;
                    this.entityId = error.entityId;
                    return false;
                }
            }

            if (errorCode === this.orderStore.constants.NO_ORDER_FOUND) {
                this.NO_ORDER_FOUND = true;
                this.knownError = true;
                this.entityId = error.entityId;
                return false;
            }

            if (errorCode === this.orderStore.constants.ORDER_IN_DRAFTED) {
                this.ORDER_IN_DRAFTED = true;
                this.knownError = true;
                this.entityId = error.entityId;
                return false;
            }

            if (errorCode === this.orderStore.constants.ORDER_IN_CONFIRMED) {
                this.ORDER_IN_CONFIRMED = true;
                this.knownError = true;
                this.entityId = error.entityId;
                return false;
            }

            if (errorCode === this.orderStore.constants.ORDER_IN_QUOTED) {
                this.ORDER_IN_QUOTED = true;
                this.knownError = true;
                this.entityId = error.entityId;
                return false;
            }

            if (errorCode === this.orderStore.constants.NO_BILL_FOUND) {
                this.NO_BILL_FOUND = true;
                this.knownError = true;
                this.entityId = error.entityId;
                return false;
            }

            if (errorCode === this.orderStore.constants.GO_FIGURE) {
                this.GO_FIGURE = true;
                this.knownError = true;
                this.entityId = error.entityId;
                return false;
            }
        }
    }

    goToOrders() {
        this.$state.go('base.orders', {orderId: this.entityId});
    }

    goToLocationPage() {
        let nextState = this.utils.getAdminStateIfApplicable('base.location');
        this.$state.go(nextState, {orderId: this.entityId});
    }

    goToAcknowledgementPage() {
        let nextState = this.utils.getAdminStateIfApplicable('base.acknowledge');
        this.$state.go(nextState, {orderId: this.entityId});
    }

    goToMajorItems() {
        let nextState = this.utils.getAdminStateIfApplicable('base.home');
        this.$state.go(nextState, {orderId: this.entityId});
    }

    showEditOrderTimeModal() {
        this.$mdDialog.show({
                controller: require('common/popup.component/edit.order.time/edit.order.time.controller'),
                controllerAs: 'edit',
                template: require('common/popup.component/edit.order.time/edit.order.time.html'),
                locals: {
                    orderId: this.entityId
                },
                parent: angular.element(document.body),
                clickOutsideToClose: true
            })
            .then(
                () => {
                    window.location.reload();
                },
                (error) => {
                    console.log(error);
                }
            );
    }

}

PkLoader.bindings = {
    load: '=pkLoader',
    loadingText: '@'
};

export default PkLoader;


// WEBPACK FOOTER //
// ./client/app/common/pk.loader.component/pk.loader.controller.js